const UnreadCountBadge = ({ count }: { count: number }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span className="flex items-center justify-center rounded-lg bg-brand-primary px-2 py-0.5 text-sm text-white md:h-[18px] md:min-w-[18px] md:rounded-full md:px-1.5 md:text-[11px] md:leading-none">
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default UnreadCountBadge;
